var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-counter-container",class:_vm.itemCounterColor},[_c('p',[_c('i',[_vm._v(_vm._s(_vm.getLabel))]),_vm._v(": "),_c('b',[_vm._v(_vm._s(_vm.counterText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }